import React from 'react';
import {FieldViewProps} from "../../../render/view";

export default function FieldStoryPoints_View(props:FieldViewProps) {

    const value = props.model[props.field.fieldId]

    if (_.isNil(value)) return false;

    const selectedOption = _.find(gd.company.settings.fields.storyPoints, (option:Option) => {return option.value===value});

    const displayValue = selectedOption? selectedOption.label : value


    return <div className="ui5-story-points s-24">{displayValue}</div>
}
